import { Box } from '@mui/material';
import type { ReactNode } from 'react';
import { designTokens } from '../tokens';
import { InformationRow, type InformationRowItem } from './InformationRow';

export type DefinitionGridItem = InformationRowItem & {
  wide?: boolean;
};

export type DefinitionGridProps = {
  items: readonly DefinitionGridItem[];
  /** 넓은 화면의 열 수입니다. 좁은 화면에서는 1열, 중간 화면에서는 2열로 표시합니다. */
  columns?: 2 | 3 | 4;
  emphasizeValues?: boolean;
  emptyValue?: ReactNode;
  testId?: string;
};

/** 상세 화면의 정보를 label 위, value 아래의 반응형 grid로 표시합니다. 기본값은 2열입니다. */
export function DefinitionGrid({ items, columns = 2, emphasizeValues = false, emptyValue = '미입력', testId }: DefinitionGridProps) {
  return <Box component="dl" data-testid={testId} sx={{
    m: 0, display: 'grid',
    gridTemplateColumns: { xs: 'minmax(0, 1fr)', sm: 'repeat(2, minmax(0, 1fr))', md: `repeat(${columns}, minmax(0, 1fr))` },
    columnGap: `${designTokens.layout.informationGridColumnGap}px`, rowGap: `${designTokens.layout.informationGridRowGap}px`,
  }}>
    {items.map((item, index) => <InformationRow key={item.id ?? index} {...item} layout="stacked" emphasizeValue={emphasizeValues} emptyValue={emptyValue} testId={testId && item.id ? `${testId}-${item.id}` : undefined} />)}
  </Box>;
}
